import Icon from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Play from '@/assets/icons/play-1.svg?react';
import styles from './details-link.module.scss';

interface DetailsLinkProps {
  link: string;
}

export const DetailsLink = ({ link }: DetailsLinkProps) => {
  return (
    <Link to={link} className={styles.link}>
      <span className={styles.linkText}>Details</span>
      <Icon
        className={styles.playIcon}
        component={() => <Play stroke={styles.playIcon} width={9} height={9} />}
      />
    </Link>
  );
};
